// Listen for clicks on the document
document.addEventListener('click', function(event) {
    let target = event.target;
    // Ensure target is an element that can have classList
    while (target !== document && target.nodeType === Node.ELEMENT_NODE && !target.classList.contains('watch-full-video')) {
        target = target.parentNode;
    }

    if (target !== document && target.classList.contains('watch-full-video')) {
        const youtubeEmbedCode = target.getAttribute('data-youtube-embed');
        const youtubeDiv = `<div id="youtubeEmbed">${youtubeEmbedCode}</div>`;

        const videoContainer = document.querySelector('.video-container');
        videoContainer.innerHTML = ''; // Clear the container
        videoContainer.innerHTML = youtubeDiv; // Insert new YouTube embed div

        const productVideoPopupWrapper = document.querySelector('.product-video-popup-wrapper');
        fadeIn(productVideoPopupWrapper, 300);
    }
});


// Function to handle the fade-in effect
function fadeIn(element, duration) {
    element.style.display = 'block';
    element.style.opacity = 0;
    let last = +new Date();
    let tick = function() {
        element.style.opacity = +element.style.opacity + (new Date() - last) / duration;
        last = +new Date();

        if (+element.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
    };
    tick();
}


// Listen for clicks on the entire document
document.addEventListener('click', function(event) {
    // Check if the clicked element has the class 'close-guide'
    if (event.target.classList.contains('close-guide')) {
        // Find the '.product-video-popup-wrapper' and start fade out
        const popupWrapper = document.querySelector('.product-video-popup-wrapper');
        fadeOut(popupWrapper, 300);

        // Remove the 'iframe' within '.video-container'
        const iframe = document.querySelector('.video-container iframe');
        if (iframe) {
            iframe.parentNode.removeChild(iframe);
        }
    }
});

// Function to handle the fade-out effect
function fadeOut(element, duration) {
    element.style.opacity = 1;

    const start = performance.now();

    requestAnimationFrame(function fade(timestamp) {
        // Calculate the normalized time elapsed
        const time = (timestamp - start) / duration;
        element.style.opacity = Math.max(1 - time, 0);

        // Continue the animation as long as the element has not yet fully faded out
        if (time < 1) {
            requestAnimationFrame(fade);
        } else {
            element.style.display = 'none';
        }
    });
}

function ipLookUp() {
    // Perform the AJAX request using the Fetch API
    fetch('https://api.ipdata.co?api-key=8fd749aec99277661f2fce3e033bc119fa632db378859834ee92a0b9')
        .then(response => response.json()) // Convert the response to JSON
        .then(response => {
            console.log('User\'s Location Data is ', response.country_name);

            // Conditional logic based on location
            if (response.country_name !== 'United Kingdom') {
                // Remove certain elements from the DOM
                document.querySelectorAll('.pdp--buttons').forEach(el => el.remove());
                document.querySelectorAll('a[aria-controls="cart-drawer"]').forEach(el => el.remove());
                document.querySelectorAll('.product-info__block-item[data-block-type="price"]').forEach(el => el.remove());
                
                //Prepent an anchor tag to .product-info__block-item[data-block-type="price"]
                const buyButtonsBlock = document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
                const dealorAnchor = document.createElement('a');
                dealorAnchor.classList.add('button', 'button--primary', 'button--full', 'locator-btn');
                dealorAnchor.href = 'https://www.cabrinhakites.com/apps/store-locator';
                dealorAnchor.textContent = "Find a Dealer";
                buyButtonsBlock.prepend(dealorAnchor);
            } else {
                console.log('Test');
                // Apply inline CSS styles
                document.querySelectorAll('.icon-cart, .top-cart-icon').forEach(el => el.style.display = 'inline-block');
                document.querySelectorAll('.payment_methods').forEach(el => el.style.display = 'block');

                // Add class to the body
                document.body.classList.add('ecomm');

                if (document.body.classList.contains('pdp--ecommerce')) {
                    document.querySelectorAll('.pdp--buttons').forEach(el => el.style.display = 'block');
                }
            }
        })
        .catch(error => {
            console.log('Request failed. Returned status of', error.message);
        });
}

// Call the function


document.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-guide-trigger')) {
        let popupID = event.target.getAttribute('data-popup-id');
        let popup = document.querySelector('.product-guide-popup-wrapper[id="' + popupID + '"]');
        if (popup) {
            popup.style.display = 'block';
            popup.style.opacity = 0;
            let opacity = 0;
            let interval = setInterval(function() {
                opacity += 0.03;
                popup.style.opacity = opacity;
                if (opacity >= 1) clearInterval(interval);
            }, 10);
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    ipLookUp();
    const popups = document.querySelectorAll('.product-guide-popup-wrapper');
    const body = document.body;

    if (popups.length > 0) {
        popups.forEach(popup => {
            body.appendChild(popup);
        });
    }
});

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('close-product-guide')) {
        const popup = event.target.closest('.product-guide-popup-wrapper');
        if (popup) {
            let opacity = 1;
            const interval = setInterval(function() {
                opacity -= 0.03;
                popup.style.opacity = opacity;
                if (opacity <= 0) {
                    clearInterval(interval);
                    popup.style.display = 'none';
                }
            }, 10);
        }
    }
});

function mobileDevice() {
  return window.innerWidth < 991;
}

document.addEventListener('DOMContentLoaded', function() {
  if (mobileDevice()) {
  const variantsLists = document.querySelectorAll('.filtered-variants-list');
  
  function checkAndCenterList(list) {
    // Reset to default alignment
    list.style.justifyContent = 'start';
    
    // Check if content width is less than container width
    if (list.scrollWidth <= list.clientWidth) {
      list.style.justifyContent = 'center';
    }
  }

  function handleAllLists() {
    variantsLists.forEach(checkAndCenterList);
  }

  // Run on load
  handleAllLists();

  // Run on window resize
  window.addEventListener('resize', handleAllLists);

  // Optional: Run when mutations are observed (for dynamically added content)
  const observer = new MutationObserver(handleAllLists);
  variantsLists.forEach(list => {
    observer.observe(list, { childList: true, subtree: true });
  });
  }
});



